'use client';

import React from 'react';
import { cva } from 'class-variance-authority';
import { twMerge } from 'tailwind-merge';

const inputClasses = cva(
  'w-full transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed',
  {
    variants: {
      variant: {
        default: 'focus:ring-blue-500',
        error: 'border-red-500 focus:ring-red-500',
        success: 'border-green-500 focus:ring-green-500',
      },
      size: {
        small: 'text-sm px-3 py-1.5',
        medium: 'text-base px-4 py-2',
        large: 'text-lg px-5 py-3',
      },
    },
    defaultVariants: {
      variant: 'default',
      size: 'medium',
    },
  }
);

const EditText = ({
  // Required parameters with defaults
  placeholder = "Alamat email Anda",
  text_font_size = "text-lg",
  text_font_family = "Plus Jakarta Sans",
  text_font_weight = "font-medium",
  text_line_height = "leading-relaxed",
  text_text_align = "left",
  text_color = "text-text-placeholder",
  fill_background_color = "bg-input-background",
  border_border_radius = "rounded-sm",
  effect_box_shadow = "shadow-[0px_0px_1px_#002d8114]",
  
  // Optional parameters (no defaults)
  layout_width,
  padding,
  position,
  
  // Standard React props
  variant,
  size,
  type = "text",
  value,
  onChange,
  disabled = false,
  className,
  id,
  name,
  required = false,
  ...props
}) => {
  // Safe validation for optional parameters
  const hasValidWidth = layout_width && typeof layout_width === 'string' && layout_width?.trim() !== '';
  const hasValidPadding = padding && typeof padding === 'string' && padding?.trim() !== '';
  const hasValidPosition = position && typeof position === 'string' && position?.trim() !== '';

  // Build optional Tailwind classes
  const optionalClasses = [
    hasValidWidth ? `w-[${layout_width}]` : '',
    hasValidPadding ? `p-[${padding}]` : '',
    hasValidPosition ? position : '',
  ]?.filter(Boolean)?.join(' ');

  // Safe change handler
  const handleChange = (event) => {
    if (disabled) return;
    if (typeof onChange === 'function') {
      onChange(event);
    }
  };

  return (
    <input data-component-id="src\components\ui\EditText.jsx:81:4" data-component-path="src\components\ui\EditText.jsx" data-component-line="81" data-component-end-line="106" data-component-file="EditText.jsx" data-component-name="input" data-component-content="%7B%22elementName%22%3A%22input%22%2C%22type%22%3A%22%5Bvar%3Atype%5D%22%2C%22id%22%3A%22%5Bvar%3Aid%5D%22%2C%22name%22%3A%22%5Bvar%3Aname%5D%22%2C%22value%22%3A%22%5Bvar%3Avalue%5D%22%2C%22%5Bspread%5D%22%3A%22true%22%7D"
      type={type}
      id={id}
      name={name}
      value={value}
      onChange={handleChange}
      placeholder={placeholder}
      disabled={disabled}
      required={required}
      className={twMerge(
        inputClasses({ variant, size }),
        text_font_size,
        `font-[${text_font_family}]`,
        text_font_weight,
        text_line_height,
        `text-${text_text_align}`,
        text_color,
        fill_background_color,
        border_border_radius,
        effect_box_shadow,
        optionalClasses,
        className
      )}
      aria-disabled={disabled}
      {...props}
    />
  );
};

export default EditText;